import { Form } from "antd";

import type { FieldMethod, FormFieldFactoryProps } from "../../types/types";
import { CreateTablePlaceholderComponent } from "../CreateTablePlaceholderComponent";
import { ContractTerminalsTable } from "./ContractTerminalsTable";

const WATCHED_FIELDS = ["siteId", "allIPT", "allOPT", "allUnattended", "allEcommerce", "allEvcharger"] as const;

export const ContractTerminalsTableField: FieldMethod = ({ field, readOnly }: FormFieldFactoryProps) => {
    return (
        <Form.Item noStyle shouldUpdate={(prevValues, currentValues) => WATCHED_FIELDS.some((f) => prevValues[f] !== currentValues[f])}>
            {({ getFieldValue }) => {
                const siteId = getFieldValue("siteId");

                if (!siteId) {
                    return <CreateTablePlaceholderComponent messageKey="table.editForm.selectSitePlaceholder" />;
                }

                const selectedTerminalTypes = {
                    allIPT: getFieldValue("allIPT"),
                    allOPT: getFieldValue("allOPT"),
                    allUnattended: getFieldValue("allUnattended"),
                    allEcommerce: getFieldValue("allEcommerce"),
                    allEvcharger: getFieldValue("allEvcharger"),
                };

                return (
                    <Form.Item key={`${field.name}FormItem`} name={field.name}>
                        <ContractTerminalsTable
                            key={field.name}
                            readOnly={readOnly}
                            siteId={siteId}
                            selectedTerminalTypes={selectedTerminalTypes}
                        />
                    </Form.Item>
                );
            }}
        </Form.Item>
    );
};
